function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_642",
  "data-name": "Group 642",
  transform: "translate(-982.268 -252.815)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_655",
  "data-name": "Path 655",
  d: "M999.129,255.869l-6.348-3.012a.438.438,0,0,0-.187-.042h-.063a.437.437,0,0,0-.4.253,1.415,1.415,0,0,1-1.278.816h-.067a1.415,1.415,0,0,1-1.278-.816.437.437,0,0,0-.4-.253h-.063a.438.438,0,0,0-.187.042l-6.348,3.012a.437.437,0,0,0-.236.5l.745,2.915a.437.437,0,0,0,.533.315l2.206-.571v7.079a.437.437,0,0,0,.437.437h9.241a.437.437,0,0,0,.437-.437v-7.079l2.206.571a.437.437,0,0,0,.533-.315l.745-2.915A.437.437,0,0,0,999.129,255.869Zm-1.247,2.777-2.328-.6a.437.437,0,0,0-.547.423v7.206h-8.366v-7.206a.437.437,0,0,0-.547-.423l-2.328.6-.547-2.141,5.71-2.709a2.294,2.294,0,0,0,1.862.962h.067a2.294,2.294,0,0,0,1.862-.962l5.709,2.709Z",
  transform: "translate(0 0)",
  fill: "#d71635"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_639",
  "data-name": "Group 639",
  transform: "translate(985.766 254.224)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_656",
  "data-name": "Path 656",
  d: "M1014.706,270.473a.437.437,0,0,1-.437-.437v-3.895a.437.437,0,1,1,.874,0v3.895A.437.437,0,0,1,1014.706,270.473Z",
  transform: "translate(-1014.269 -265.704)",
  fill: "#d71635"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_640",
  "data-name": "Group 640",
  transform: "translate(995.007 254.224)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_657",
  "data-name": "Path 657",
  d: "M1099.244,270.473a.437.437,0,0,1-.437-.437v-3.895a.437.437,0,1,1,.874,0v3.895A.437.437,0,0,1,1099.244,270.473Z",
  transform: "translate(-1098.807 -265.704)",
  fill: "#d71635"
})));

var SvgIconShirt = function SvgIconShirt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.111,
    height: 13.732,
    viewBox: "0 0 17.111 13.732",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShirt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconShirt.ccc23541.svg";
export { ForwardRef as ReactComponent };